
import { defineComponent, PropType } from 'vue'
import { DropdownOptionResponse } from '@/@types/responses/common/DropdownOptionResponse'

export default defineComponent({
  name: 'Dropdown',
  props: {
    modelValue: {
      type: [String, Number],
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array as PropType<Array<DropdownOptionResponse<any>>>,
      required: true
    },
    showInactive: {
      type: Boolean,
      default: false
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  computed: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    activeOptions(): DropdownOptionResponse<any>[] {
      return this.options.filter(o => o.active || this.showInactive)
    }
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChanged(e: any): void {
      const value = e.currentTarget.value
      const index = this.options.findIndex(o => o.id === value || o.id === parseInt(value))
      if (index === -1)
        this.onClearClicked()
      else
        this.$emit('update:modelValue', this.options[index].id)
    },
    onClearClicked(): void {
      if (typeof(this.modelValue) === 'string')
        this.$emit('update:modelValue', '')
      else
        this.$emit('update:modelValue', undefined)
    }
  }
})
